import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table as Table2,
    Pagination,
    Checkbox,
    Modal,
    Upload,
    Radio,
    Transfer,
    Form,
    Col,
    Rate,
    Divider,
    Tree,
    Avatar,
    message
} from 'antd';
import { Redirect, Link, withRouter } from 'react-router-dom';
import store from "../store/store.js";
import { CloseOutlined, EditOutlined, PlusOutlined ,FolderAddOutlined} from '@ant-design/icons'
import {
    UploadOutlined,
    DeleteOutlined,
    FormOutlined,
    MinusSquareOutlined,
    PhoneOutlined,
    WechatOutlined,
    MailOutlined,
    HomeOutlined,
    PlusSquareOutlined,
    CheckCircleOutlined,
    UserOutlined,
    CheckOutlined
} from '@ant-design/icons'
import moment from 'moment';
import 'braft-editor/dist/index.css'
import BraftEditor from 'braft-editor'
import Table from 'braft-extensions/dist/table'
import { ContentUtils } from 'braft-utils'
import { ImageUtils } from 'braft-finder'

const { Option, OptGroup } = Select;
const { Search, TextArea } = Input;
const options = {
    defaultColumns: 3, // 默认列数
    defaultRows: 3, // 默认行数
    withDropdown: true, // 插入表格前是否弹出下拉菜单
    columnResizable: true, // 是否允许拖动调整列宽，默认false
    exportAttrString: 'border="1" style="border-collapse: collapse"', // 指定输出HTML时附加到table标签上的属性字符串
    // includeEditors: [], // 指定该模块对哪些BraftEditor生效，不传此属性则对所有BraftEditor有效
    // excludeEditors: []  // 指定该模块对哪些BraftEditor无效
}

BraftEditor.use(Table(options))

class Qxedit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {

            },


            visible: false,
            loading: false,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {


    }

    sub() {
        let that = this
        that.setState({
            loading: true
        })
        let arr = that.state.condition
        fetch('/ProjectResource/progressSave', {
            method: "POST",
            body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 1) {
                    message.success(data.msg)
                    this.props.refresh()
                    this.mdchange()
                } else {
                    message.error(data.msg)
                    that.setState({
                        loading: false
                    })
                }
            })
    }

    mdchange() {
        let that = this
        let visible = !that.state.visible
        that.setState({
            visible
        })
        if (visible) {
            that.setState({
                condition: { ...that.state.condition, content: this.props.content, id: this.props.id, editorState: BraftEditor.createEditorState(this.props.content) }
            })
        } else {
            that.setState({
                condition: {

                },
                loading: false
            })
        }
    }


    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.condition, { [name]: dateString })
        this.setState({
            condition: data
        })
    }

    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, { [name]: value })
        this.setState({
            condition: data
        })
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, { [name]: value })
        this.setState({
            condition: data
        })
    }

    onCheckboxChange(name, e) {
        let that = this
        let value = e.target.checked
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, { [name]: value })
        this.setState({
            condition: data
        })
    }

    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Option value={Number(item.id)} key={index}>{item.name}</Option>
            )
        }
    }

    // 上传图片
    picChange(name, info) {
        // console.log(info)
        if (info.file.status === 'uploading') {
            this.setState({ loading2: true });
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            // console.log(info.file.response)

            var fjlist = this.state.condition[name]
            if (!fjlist) {
                fjlist = []
            }
            if (info.file.response.status == 0) {
                message.error(info.file.response.msg)
                return;
            }
            fjlist = fjlist.concat(info.file.response)
            let data = Object.assign({}, this.state.condition, { [name]: fjlist })
            this.setState({
                condition: data,
                loading2: false,
            })
        }
    };

    delpic(index, name, e) {
        var fjlist = this.state.condition[name]
        fjlist.splice(index, 1)
        let data = Object.assign({}, this.state.condition, { [name]: fjlist })
        this.setState({
            condition: data,
        })
    }

    editorChange = (editorState) => {
        // console.log(editorState)
        let data = Object.assign({}, this.state.condition, { editorState: editorState, content: editorState.toHTML() })
        this.setState({
            condition: data
        })

    }
    // 富文本上传附件
    picChange2(name, info) {
        // console.log(info)
        if (info.file.status === 'uploading') {
            this.setState({ loading2: true });
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            // console.log(info.file.response)
            if (info.file.response.status == 0) {
                message.error(info.file.response.msg)
                return;
            }
            let text = ContentUtils.insertText(this.state.condition[name], info.file.response.name, ['COLOR-00F', 'UNDERLINE'], {
                type: 'LINK', mutability: 'MUTABLE', data: {
                    href: info.file.response.url, target: '_blank',
                },
            })
            let data = Object.assign({}, this.state.condition, {
                [name]: text, content: text.toHTML()
            })
            this.setState({
                condition: data
            })
        }
    };

    render() {
        //多媒体上传
        const myUploadFn = (param) => {

            const serverURL = '/Ajax/uploads'
            const xhr = new XMLHttpRequest
            const fd = new FormData()

            const successFn = (response) => {
                // 假设服务端直接返回文件上传后的地址
                // 上传成功后调用param.success并传入上传后的文件地址
                let reg = /["\\]/g
                var url = xhr.responseText.replace(reg, "");
                param.success({
                    // url: xhr.responseText,
                    url: url, meta: {
                        // id: 'xxx',
                        // title: 'xxx',
                        // alt: 'xxx',
                        loop: false, // 指定音视频是否循环播放
                        autoPlay: false, // 指定音视频是否自动播放
                        controls: true, // 指定音视频是否显示控制栏
                        poster: '', // 指定视频播放器的封面
                    }
                })
            }

            const progressFn = (event) => {
                // 上传进度发生变化时调用param.progress
                param.progress(event.loaded / event.total * 100)
            }

            const errorFn = (response) => {
                // 上传发生错误时调用param.error
                param.error({
                    msg: 'unable to upload.'
                })
            }

            xhr.upload.addEventListener("progress", progressFn, false)
            xhr.addEventListener("load", successFn, false)
            xhr.addEventListener("error", errorFn, false)
            xhr.addEventListener("abort", errorFn, false)

            fd.append('file', param.file)
            xhr.open('POST', serverURL, true)
            xhr.send(fd)

        }
        const controls = ['undo', 'redo', 'separator', 'font-size', 'line-height', 'letter-spacing', 'separator', 'text-color', 'bold', 'italic', 'underline', 'strike-through', 'separator', 'superscript', 'subscript', 'remove-styles', 'separator', 'text-indent', 'text-align', 'separator', 'headings', 'list-ul', 'list-ol', 'code', 'blockquote', 'table', 'media', 'separator', 'hr', 'link', 'separator', 'separator', 'clear']
        const extendControls = [{
            key: 'antd-uploader', type: 'component', component: (<Upload
                showUploadList={false}
                action="/Ajax/upload"
                onChange={this.picChange2.bind(this, 'editorState')}
            >
                {/* 这里的按钮最好加上type="button"，以避免在表单容器中触发表单提交，用Antd的Button组件则无需如此 */}
                <Button className="control-item button upload-button" data-title="上传附件">
                    <FolderAddOutlined />
                </Button>
            </Upload>)
        }]
        return (
            <>
                <a href='javascript:void(0)' onClick={this.mdchange.bind(this)}>{this.props.title}</a>

                <Modal title="编辑" maskClosable={false} destroyOnClose={true} width={1200}
                    visible={this.state.visible} onCancel={this.mdchange.bind(this)} footer={null}>
                    <div className='shuru'>
                        <div className="editor-wrapper" id='editor' style={{ border: '1px solid #bbb' }}>
                            <BraftEditor
                                value={this.state.condition.editorState}
                                onChange={this.editorChange}
                                controls={controls}
                                media={{ uploadFn: myUploadFn }}
                                contentStyle={{ height: 250, }}
                                extendControls={extendControls}
                                // onFocus={this.editFocus.bind(this)}
                                ref={instance => this.editorInstance = instance}
                            />
                        </div>
                        <div style={{ paddingTop: 20 }}>
                            <Row justify="center">
                                <Space>
                                    <Button type="primary" onClick={this.sub.bind(this)}>提交</Button>
                                </Space>
                            </Row>
                        </div>
                    </div>

                </Modal>
            </>
        )
    }
}

export default Qxedit
